import { createPortal } from "react-dom";
import { X } from "lucide-react";
import type { ReactNode } from "react";

/**
 * Admininfo som panel längst ner på skärmen. Används på pekskärmar (mobil,
 * platta, appen) där en hover-bubbla inte går att visa utan att bryta layouten.
 */
export function AdminInfoSheet({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  if (!open || typeof document === "undefined") return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[110] flex items-end justify-center bg-foreground/40 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Admininfo"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="max-h-[80vh] w-full max-w-md overflow-y-auto rounded-t-2xl border border-border bg-popover p-4 pb-[calc(env(safe-area-inset-bottom,0px)+1rem)] text-xs leading-relaxed text-popover-foreground shadow-2xl"
      >
        <div className="mb-2 flex items-center justify-between gap-3">
          <p className="font-heading text-[11px] font-bold uppercase tracking-wide text-primary">
            Admininfo
          </p>
          <button
            type="button"
            onClick={onClose}
            aria-label="Stäng"
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground transition-colors active:bg-muted"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body,
  );
}
